export default __webpack_public_path__ + "static/media/Clan Bound Bracers of the Plains.cd697cf7.jpg";